import React from 'react';
import { withRouter } from 'react-router-dom';
import Axios from 'axios';

import { Toast, ActivityIndicator, Modal } from 'antd-mobile';
import BasicLayout from 'Common/BasicLayout';
import Error from 'Common/Error';

import util from 'Utiljs';
import api from './service/api';
import Sksx from './utils/sksx';
import Routes from './routes';
import routesListen from './utils/routesListen';
import pubsub from './utils/pubsub';

import './App.less';

class App extends React.Component{

  // 查询当前城市
  static searchCity(areaCode, allCity) {
    let currentCity = {}; 
    let isOpenCity = false; 
    let i = 0; 
    const {length} = allCity;
    for (i; i < length; i += 1) {
      if (areaCode === allCity[i].areaCode) {
        isOpenCity = true;
        currentCity = allCity[i];
        break;
      }
    }
    return {isOpenCity, currentCity};
  }

  constructor(props){
    super(props);
    
    pubsub();
    routesListen(props); // 2021年08月05日snn增加监听路由变化

    this.state = {
      ...util.getUrlParams(),
      // 过滤微信公众号授权数组 'maoyan/performance/area-select'
      skipPage: ['opencardapp', 'app', 'maoyan', 'damai'],
      hashLocation: window.location.hash || '#/v3home',
      loading: true,
      // 默认城市 北京
      defaultCity: {
        areaCode: '010',
        cityCode: '110100',
        cityName: '北京'
      },
      // 默认经纬度 北京
      defaultPosition: {
        lng: 116.397471,
        lat: 39.908696,
        status: 0
      },
      isAli: false,   // 支付宝环境 默认false
      webviewLoginStatus: false, // webview登录状态
      userInfo: {},
      limitFlow: false
    };
  }

  componentWillMount() {
    api.getTimestamp();
  }

  componentDidMount() {
    this.limitFlowCheck(() => {
      const env = process.env.REACT_APP_SKSXENV;
      const trackAppId = { dev: '3FTJZnvNiqE2cps0', test: '3FTJZnvNiqE2cps0', prod: 'ERy70pscFG3prRUg' };
      Sksx.init(trackAppId[env]);

      // 判断如果是微信环境，依然走旧的逻辑
      if (window.sayhi.isWX && !window.sayhi.isApp) {
        // 获取链接中的userInfo参数
        // 获取连接中的plateMiniApp
        const hashSearch = window.location.hash.split('?')[1];
        const { userInfo, plateMiniApp } = hashSearch ? util.getUrlParams(`?${hashSearch}`) : util.getUrlParams();
        const xauth = hashSearch ? util.getUrlParams(`?${hashSearch}`)['X-Authorization'] : util.getUrlParams()['X-Authorization'];
        if (xauth) {
          const decodeXAuth = decodeURIComponent(xauth).replace(/"/g, '');
          window.localStorage.setItem('token', JSON.stringify(decodeXAuth));
        }
        // 请求拦截
        Axios.interceptors.request.use(data => {
          if (plateMiniApp) {
            // eslint-disable-next-line no-param-reassign
            data.headers.common['plate-mini-app'] = decodeURIComponent(plateMiniApp);
          }
          if (xauth) {
            // eslint-disable-next-line no-param-reassign
            data.headers.common['X-Authorization'] = decodeURIComponent(xauth).replace(/"/g, '');
          }
          // 获取请求方式
          const {method} = data;
          // 若存在userInfo
          if (userInfo) {
            if (method === 'get') {
              if (!data.params) {
                // eslint-disable-next-line no-param-reassign
                data.params = {};
              }
              // eslint-disable-next-line no-param-reassign
              data.params.userInfo = encodeURIComponent(userInfo);
            } else if (method === 'post') {
              // eslint-disable-next-line no-param-reassign
              data.url += `?userInfo=${encodeURIComponent(userInfo)}`;
            }
          }
          return data;
        });

        // 响应拦截
        Axios.interceptors.response.use((data) => {
          const response = data.data;
          if (Number(response.code) === 504 || Number(response.code) === 401 || response.httpCode === 401) {
            Toast.hide();
            // 获取当前页面路由
            const route = (window.location.hash === '#/' || !window.location.hash) ? '#/home' : window.location.hash;
            // 存储当前路由
            window.localStorage.setItem('pageRoute', route);
            // 返回Promise
            return new Promise((resolve) => {
              util.login(true).then(() => {
                resolve(data);
              });
            });
          } if (Number(response.code) === 700) {
            Toast.hide();
            this.setState({ loading: true });
            return data;
          } 
            return data;
          
        }, (error) => Promise.reject(error));
      }

      // 跳过OAuth流程
      const userAgent = window.navigator.userAgent.toLowerCase();
      const iswx = /micromessenger/.test(userAgent);
      window.iswx = iswx;

      // 支付宝环境直接出提示框
      const isAli = /alipayclient/.test(userAgent);
      if(isAli){
        this.setState({ 
          loading: false, 
          isAli 
        });
        return;
      }

      const { skipPage, hashLocation, mockLogin } = this.state;
      if (skipPage.indexOf(hashLocation.split('/')[1]) !== -1) {
        // btgApp的loading false 在BasicLayout里面判断
        if (!window.sayhi.isBtgApp) {
          this.setState({ loading: false });
        }
        return;
      }

      if ((window.sayhi.isWX && !window.sayhi.isApp) || mockLogin === '1') {
        // 登陆
        util.login().then(() => this.loginCallback());
      } else {
        window.sayhi.isSkipWxLogin = true;
        this.setState({ loading: false });
      }
    });
  }

  // 获取城市列表
  getCityList(callback) {
    const { defaultCity } = this.state;
    api.getCityList().then((response) => {
      if (Number(response.code) === 0) {
        // 获取全部城市列表
        const allCity = response.data;
        // 存储全部城市列表
        util.setSession('allCity', allCity);
        // 获取最后一次选择的城市
        const lastCity = util.getLocalStorage('lastCity');
        // 若未获取到最后一次选择的城市 则认为是首次进入
        if (!lastCity) {
          // 设置当前城市
          util.setSession('currentCity', defaultCity);
          // 设置当前城市
          this.setCurrentCity(defaultCity, true, callback);
          return;
        }
        // 获取cookie中的城市
        const currentCity = util.getCookie('current_city');
        // 若cookie中有城市存在 则不使用高德定位
        if (currentCity) {
          const { areaCode, cityName } = JSON.parse(currentCity);
          // 询问是否切换城市
          this.inquiryChangeCity(areaCode, allCity, cityName, lastCity, false, callback);
          return;
        }
        // 初始化城市
        this.initCity(lastCity, allCity, callback);
      } else {
        Modal.alert('温馨提示', response.message, [
          {text: '返回', style: {color: '#333'}}
        ]);
      }
    });
  }

  // 设置当前城市
  setCurrentCity(city, isSetCookie, callback) {
    // 当前城市为北京
    util.setSession('city', city);
    // 最后一次进入城市为北京
    util.setLocalStorage('lastCity', city);
    // 将当前城市存入cookie 过期时间为1天
    if (isSetCookie) {
      util.setCookie('current_city', JSON.stringify(city), 60 * 60 * 24);
    }
    this.setState({loading: false}, () => {
      if (callback) {
        callback();
      }
    });
  }

  limitFlowCheck = callback => {
    api.getLimitFlow().then(res => {
      const randomNum = Math.floor(Math.random() * 11);
      const limitFlag = util.getLocalStorage('limitFlow');
      if (!limitFlag) {
        util.setLocalStorage('limitFlow', { random: randomNum, time: +new Date() });
        this.probabilityCheck(res, randomNum, callback);
        return;
      }
      const currentTime = +new Date();
      const { random, time } = limitFlag;
      // 若大于五分钟 则使用新的随机数
      if (currentTime - time >= (5 * 60 * 1000)) {
        util.setLocalStorage('limitFlow', { random: randomNum, time: +new Date() });
        this.probabilityCheck(res, randomNum, callback);
      } else {
        this.probabilityCheck(res, random, callback);
      }
    });
  }

  // 限流检查
  probabilityCheck (probability, random, callback) {
    if (probability.indexOf(`${random}`) >= 0) {
      this.setState({ loading: false, limitFlow: true });
      return;
    }
    callback();
  }

  // 询问是否切换城市
  inquiryChangeCity(areaCode, allCity, dialogCityName, lastCity, isSetCookie, callback) {
    // 获取默认城市
    const {defaultCity} = this.state;
    // 查询当前城市
    const searchInfo = App.searchCity(areaCode, allCity);
    const { currentCity, isOpenCity } = searchInfo;

    // 存储当前城市 首页商圈判断
    util.setSession('currentCity', currentCity);

    // 若当前 定位城市 与 上次选择城市相同 则当前城市切换到定位城市
    // 若当前 定位城市 与 上次选择城市不同 且是开放城市 则询问是否切换城市
    // 若当前 定位城市 与 上次选择城市不同 且不是开放城市 则默认为北京
    if (currentCity.areaCode === lastCity.areaCode) {
      // 设置当前城市
      this.setCurrentCity(currentCity, isSetCookie, callback);
    } else if (isOpenCity) {
        // 询问切换城市
        Modal.alert('温馨提示', `GPS定位显示您在${dialogCityName}，是否切换城市?`, [
          {
            text: '不切换',
            onPress: () => {
              // 埋点
              window._sksx.push(['_track', "index_switch_city_no"]);

              // 设置当前城市为上次选择城市
              this.setCurrentCity(lastCity, isSetCookie, callback);
            }
          },
          {
            text: '切换',
            onPress: () => {
              // 埋点
              window._sksx.push(['_track', "index_switch_city",
                {
                  city_code: currentCity.cityCode,
                  city_name: currentCity.cityName
                }
              ]);
              // 设置当前城市
              this.setCurrentCity(currentCity, isSetCookie, callback);
            }
          }
        ]);
      } else {
        // 不是开放城市 默认北京
        this.setCurrentCity(defaultCity, isSetCookie, callback);
      }
  }

  // 初始化城市
  initCity(lastCity, allCity, callback) {
    // 获取默认城市及经纬度
    const { defaultCity, defaultPosition } = this.state;
    // 若非首次进入 则使用高德接口获取当前定位
    util.getLocationByAMap((status, result) => {
      if (status === 'complete') {
        // 获取经纬度及当前城市
        const { position, addressComponent } = result;
        // 获取当前城市数据
        // city:城市名 province:省份名 citycode:城市编码
        const { city, province, citycode } = addressComponent;
        // 存储当前经纬度
        util.setSession('USER/POSITION', { ...position, status: 1 });

        // 询问是否切换城市
        this.inquiryChangeCity(citycode, allCity, (city || province), lastCity, true, callback);

      } else {
        // 若定位失败
        // 设置当前城市及经纬度为北京
        util.setSession('USER/POSITION', defaultPosition);
        // 存储当前城市 首页商圈判断
        util.setSession('currentCity', defaultCity);
        this.setCurrentCity(defaultCity, true, callback);
      }
    });
  }

  // 登陆回调
  loginCallback() {
    // 获取当前环境
    util.isMiniProgram(res => {
      // 存储当前环境 true为微信小程序环境
      window.isMiniProgram = res;
      // 获取当前hash
      const {hash} = window.location;
      // 正则表达式
      const reg = /home$|pick|paypoint$|profile$/;
      if (hash.search(reg) !== -1) {
        // 匹配页面成功，当前页面需要城市选择
        this.getCityList();
      } else {
        // 渲染页面
        this.setState({loading: false});
      }
    });
  }

  webviewLoginCallback (data) {
    this.setState(
      !window.sayhi.isBtgApp
      ? { ...data } 
      : { ...data, loading: false }
    );
  }

  render() {
    const { webviewLoginStatus, userInfo, loading, isAli, limitFlow } = this.state;
    return (
      <div id='app'>
        {
          !loading
            ?
              <>
                {
                  limitFlow
                    ?
                      <Error />
                    :
                      <>
                        <Modal
                          visible={isAli}
                          transparent
                          maskClosable={false}
                          title="温馨提示"
                        >
                          <div>
                            请前往微信搜索“首客首享”<br />
                            公众号或“首客首享”小程序，<br />
                            使用手机号登录后查看【我的卡券】<br />
                          </div>
                        </Modal>
                        <Routes 
                          getCityList={() => this.getCityList()} 
                          webviewLoginStatus={webviewLoginStatus}
                          userInfo={userInfo}
                        />
                      </>
                }
              </>
            :
              <ActivityIndicator toast text="正在加载" />
        }
        <BasicLayout 
          webviewLoginCallback={data => this.webviewLoginCallback(data)} 
        />
      </div>
    );
  }
}

export default withRouter(App);
